import React from 'react';
import './Card.styles.scss';
import { ComponentProps } from './Card.logic';

/* Components */
import Icon from '../Icon/Icon';
import Button from '../Button/Button';
import Video from '../Video/Video';

const Card: React.FC<ComponentProps> = ({
  icon,
  iconImage,
  image,
  imageURL,
  helper,
  imageAlt,
  headline,
  headlineURL,
  subhead,
  id,
  type,
  className,
  btnLabel,
  btnURL,
  videoID,
  videoPlatform,
  onClickHelper,
  onImageClick,
}) => {
  return (
    <div
      className={`card ${type ? `card-type-${type}` : ''} ${className}`}
      id={id}
    >
      <div className="image-group">
        {videoID ? (
          <Video videoID={videoID} platform={videoPlatform || 'youtube'} />
        ) : (
          <div className="image-group">
            {image && imageURL ? (
              <a href={imageURL} target="_blank" rel="noopener noreferrer">
                <img src={image} alt={imageAlt} className="card-image" />
              </a>
            ) : (
              image && <img src={image} alt={imageAlt} className="card-image" />
            )}
          </div>
        )}
      </div>
      <div className="content-group">
        <div className="headline-group">
          {/* Display icon or iconImage */}
          {icon && <Icon icon={icon} />}
          {iconImage && <Icon iconImage={iconImage} onClick={onImageClick} />}
          {/* Display clickable headline or standalone headline */}
          {headline && headlineURL ? (
            <a
              href={headlineURL}
              target="_blank"
              rel="noreferrer"
              className="headline-link"
              dangerouslySetInnerHTML={{ __html: headline }}
            ></a>
          ) : (
            headline && (
              <p
                className="headline"
                dangerouslySetInnerHTML={{ __html: headline }}
              ></p>
            )
          )}
        </div>
        <div className="details-group">
          {subhead && <p className="subhead">{subhead}</p>}
          {btnURL && <Button url={btnURL} label={btnLabel} />}
        </div>
        {helper && (
          <p className="helper">
            {onClickHelper ? (
              <>
                {helper.replace('Read More', '').trim()}
                <span onClick={onClickHelper} className="read-more">
                  Read More
                </span>
              </>
            ) : (
              helper
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default Card;
